import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { withDashboardContext, withRouter } from '@stackhouse/dashboard-components/Dashboard'

import { Flex } from '@stackhouse/styled-elements'

import ReportFilterPage from './report-filter'

class ReportPage extends PureComponent {

    static propTypes = {
        functionName: PropTypes.string.isRequired
    }

    constructor(props) {
        super(props)
        this.state = {}
        this.filterRef = React.createRef()
    }

    getFilter = () => {
        return this.filterRef.current.getFilter()
    }

    render() {
        const { functionName } = this.props
        return (
            <Flex column fill>
                <ReportFilterPage
                    ref={this.filterRef}
                    functionName={functionName}
                />
            </Flex>
        )
    }
}

export default withDashboardContext(withRouter(ReportPage), ({ client, withLoader }) => ({ client, withLoader }))
